<ion-header #header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="individual"></ion-back-button>
        </ion-buttons>
        @if (match && (match?.discipline === 'PICKLEBALL' || match?.discipline === 'BADMINTON' || match?.discipline === 'TABLE_TENNIS' || match?.discipline === 'SQUASH')) {
            @if (canViewOnDevice && isMobile || isTablet) {
                <ng-container *ngTemplateOutlet="segmentDropdown"></ng-container>
            }

            <ion-button class="ion-no-margin undo-btn  {{themeService?.isDarkMode ? 'dark' : 'light'}}" (click)="undo()"
                *ngIf="match?.matchStatus !== 'TBP'" slot="end" translate>
                <ion-icon name="arrow-undo-outline"></ion-icon>
            </ion-button>
        } @else {
            @if (isTablet) {
                <div style="text-align: center; width: 100%;">
                    <ng-container *ngTemplateOutlet="segmentTmp"></ng-container>
                </div>
            }

            @if (isMobile) {
                <ion-title>{{"Official's View" | translate}}</ion-title>
            }
        }

        <ion-buttons slot="end">
            <app-network-status></app-network-status>
            <ion-button color="dark" (click)="moreOptions()">
                <ion-icon slot="start" name="apps"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    @if (canViewOnDevice && isMobile && match && match?.discipline != 'PICKLEBALL' && match?.discipline != 'BADMINTON' && match?.discipline != 'TABLE_TENNIS' && match?.discipline != 'SQUASH')
    {
        <ion-toolbar>
            <ng-container *ngTemplateOutlet="segmentTmp"></ng-container>
        </ion-toolbar>
    }
</ion-header>

<ion-content [scrollY]="isMobile || selectedSegment !== 'scoring'">
    @if (canViewOnDevice) {
        @if (match) {
            @if (['PICKLEBALL', 'BADMINTON', 'TABLE_TENNIS', 'SQUASH'].includes(match.discipline)) {
                @if (selectedSegment === 'scoring' && headerHeight && (match.tie ? tie : true)) {
                            <!-- Pickleball official view -->
                            <app-official-view-for-pickleball
                            [match]="match"
                            [tie]="tie"
                            [headerHeight]="headerHeight"
                            [scoreFormat]="scoreFormat"
                            (addPointSideNumber)="addPoint($event)"
                            (undo)="undo()"
                            (resumeSuspendedMatch)="resumeSuspendedMatch()">
                            </app-official-view-for-pickleball>

                } @else if (selectedSegment === 'points') {
                    <app-score-list
                        [isOfficial]="true"
                        [match]="match">
                    </app-score-list>
                    }
                }
                @else {
                @if (match.score && match.matchStatus === 'IN_PROGRESS') {
                    <div #ticker class="ticker">
                        <div class="ticker-info">
                            @if (match.score?.server?.sideNumber) {
                            <div class="ticker-label">Server: {{ bhs.getPlayersNames(match, match.score.server.sideNumber, 'full',
                                match.score?.server?.playerNumber)}}</div>
                            <div class="ticker-value">{{ match | ticker }}</div>
                            }
                        </div>

                        <div class="match-time">
                            <div class="ticker-label">
                                {{'Match' | translate}}
                            </div>
                            <div class="ticker-value">
                                <app-match-duration [match]="match"></app-match-duration>
                            </div>
                        </div>

                        @if(match?.matchStatus !== 'TBP') {
                        <div class="swap-side">
                            <ion-button style="height: 56px;" class="ion-no-margin" color="tertiary" (click)="swapSides()"
                                expand="full">
                                <ion-icon name="swap-horizontal"></ion-icon>
                            </ion-button>
                        </div>
                        }
                    </div>
                }

                <div [hidden]="selectedSegment !== 'scoring'">
                    @if (isTablet) {
                    <div #violations>
                        <ion-row [style.background]="rowStyle">
                            <ion-col size="6" class="ion-no-padding">
                                <app-violation-shortcuts [match]="match" [sideNumber]="isReverse ? 2 : 1"
                                    (overrule)="addOverrule($event)" (time)="addTimeViolation($event)"
                                    (break)="addInterruption($event)" (code)="addCodeViolation($event)"></app-violation-shortcuts>
                            </ion-col>

                            <ion-col size="6" class="ion-no-padding">
                                <app-violation-shortcuts [match]="match" [sideNumber]="isReverse ? 1 : 2"
                                    (overrule)="addOverrule($event)" (time)="addTimeViolation($event)"
                                    (break)="addInterruption($event)" (code)="addCodeViolation($event)"></app-violation-shortcuts>
                            </ion-col>
                        </ion-row>
                    </div>
                    }

                    <ng-container *ngTemplateOutlet="playerBoxTemplate"></ng-container>

                    @if (match?.matchStatus === 'TBP') {
                    <ion-row>
                        <ion-col style="margin: 30px" class="ion-text-center">
                            <app-start-match [match]="match" itemStyle="official"></app-start-match>
                        </ion-col>
                    </ion-row>
                    } @else {
                    <ion-row [style.height.px]="rowHeight">
                        <ion-col [size]="isTablet ? 4 : 6">
                            <app-add-point-button [sideNumber]="isReverse ? 2 : 1"
                                [sidePointScore]="!isReverse ? match.score.side1PointScore : match.score.side2PointScore"
                                [winningSide]="match.winningSide" [isCompleted]="isCompleted()" [isInterrupted]="isInterrupted()"
                                [fontSize]="rowHeight/2" [backgroundColor]="isReverse ? sideColors[1] : sideColors[0]"
                                (addPoint)="addPoint({sideNumber: $event})"></app-add-point-button>
                        </ion-col>

                        @if (isTablet) {
                        <ion-col size="4">
                            <ng-container *ngTemplateOutlet="gameScoreTemplate"></ng-container>
                        </ion-col>
                        }

                        <ion-col [size]="isTablet ? 4 : 6">
                            <app-add-point-button [sideNumber]="isReverse ? 1 : 2"
                                [sidePointScore]="isReverse ? match.score.side1PointScore : match.score.side2PointScore"
                                [winningSide]="match.winningSide" [isCompleted]="isCompleted()" [isInterrupted]="isInterrupted()"
                                [fontSize]="rowHeight/2" [backgroundColor]="isReverse ? sideColors[0] : sideColors[1]"
                                (addPoint)="addPoint({sideNumber: $event})"></app-add-point-button>
                        </ion-col>

                    </ion-row>

                    <ng-container *ngTemplateOutlet="scoringButtons"></ng-container>

                    @if (isMobile) {
                    <ng-container *ngTemplateOutlet="gameScoreTemplate"></ng-container>
                    }
                    }

                    <!-- START MOBILE VIEW -->
                    @if (isMobile && platform.isPortrait()) {
                    <div [hidden]="selectedSegment !== 'scoring'">

                        @if (match.matchStatus === 'SUSPENDED') {
                        <ion-row [style.height.px]="rowHeight / 2">
                            <ion-col size="12">
                                <ion-button style="height: 100%;" (click)="resumeSuspendedMatch()" expand="block" color="tertiary">
                                    {{'Resume suspended match' | translate}}
                                </ion-button>
                            </ion-col>
                        </ion-row>
                        } @else {
                        <ion-row class="stopwatch" [style.height.px]="rowHeight / 2">
                            <ion-col>
                                @if(match.matchStatus === 'TBP') {
                                <app-stopwatch [rowHeight]="rowHeight / 2 - 4" [showButtons]="!scoreFormat?.timedSetDuration"
                                    #warmUpClock [match]="match" [clockInputValue]="getClock(clockName.WARM_UP)"
                                    [displayType]="'OFFICIAL_VIEW'"></app-stopwatch>
                                } @else {
                                <app-stopwatch [rowHeight]="rowHeight / 2 - 4" [showButtons]="!scoreFormat?.timedSetDuration"
                                    #pointBreakClock [match]="match" [clockInputValue]="getClock(clockName.POINT_BREAK)"
                                    [displayType]="'OFFICIAL_VIEW'"></app-stopwatch>
                                }
                            </ion-col>

                            @if(scoreFormat?.timedSetDuration > 0) {
                            <ion-col>
                                <app-stopwatch [rowHeight]="rowHeight / 2 - 4" [showButtons]="!scoreFormat?.timedSetDuration"
                                    #setTimeClock [match]="match" [clockInputValue]="getClock(clockName.SET_TIME)"
                                    [displayType]="'OFFICIAL_VIEW'"></app-stopwatch>
                            </ion-col>
                            }
                        </ion-row>
                        }
                        @if(match.discipline !== 'BADMINTON' && match.discipline !== 'TABLE_TENNIS') {
                            <ion-row>
                                <ion-col class="set set-border-right">
                                    <app-ball-change [match]="match"></app-ball-change>
                                </ion-col>
                            </ion-row>
                        }
                    </div>
                    }
                    <!-- END MOBILE VIEW -->

                    <!-- START TABLET VIEW -->
                    @if (isTablet && platform.isLandscape()) {

                    @if (match.matchStatus === 'SUSPENDED') {
                    <ion-row [style.height.px]="rowHeight / 2">
                        <ion-col size="12">
                            <ion-button style="height: 100%;" (click)="resumeSuspendedMatch()" expand="block" color="tertiary">
                                {{'Resume suspended match' | translate}}
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    } @else {
                    <ion-row [style.height.px]="rowHeight / 2">
                        <ion-col>
                            @if(match.matchStatus === 'TBP') {
                            <app-stopwatch #warmUpClock [rowHeight]="rowHeight / 2 - 4" [match]="match"
                                [clockInputValue]="getClock(clockName.WARM_UP)" [displayType]="'OFFICIAL_VIEW'"></app-stopwatch>
                            } @else {
                            <app-stopwatch #pointBreakClock [rowHeight]="rowHeight / 2 - 4" [match]="match"
                                [clockInputValue]="getClock(clockName.POINT_BREAK)" [displayType]="'OFFICIAL_VIEW'"></app-stopwatch>
                            }
                        </ion-col>
                        @if(scoreFormat?.timedSetDuration > 0) {
                        <ion-col>
                            <app-stopwatch [rowHeight]="rowHeight / 2 - 4" #setTimeClock [match]="match"
                                [clockInputValue]="getClock(clockName.SET_TIME)" [displayType]="'OFFICIAL_VIEW'"></app-stopwatch>
                        </ion-col>
                        } @else {
                        <ion-col>
                            <app-ball-change [match]="match"></app-ball-change>
                        </ion-col>
                        }
                    </ion-row>
                    }
                    <!-- END Scoring view -->
                    }
                    <!-- END TABLET VIEW -->
                </div>
                <app-infringement-list #violationList [hidden]="selectedSegment !== 'violation'" [side1Color]="sideColors[0]"
                    [side2Color]="sideColors[1]" [match]="match" (addPoint)="addPoint($event)"
                    (addGame)="addGame($event)"></app-infringement-list>
                @if (selectedSegment === 'points') {
                    <app-score-list [isOfficial]="true" [match]="match"></app-score-list>
                }
            }

        }
    } @else {
    <!-- START DESKTOP VIEW -->
    <ion-card>
        <ion-card-header>
            <ion-card-subtitle>{{'Invalid device' | translate}}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
            {{'Chair official view is only avaialble on phones and tablets. If you are viewing this from a phone or
            tablet please reach out to us.' | translate}}
            <ion-button [routerLink]="['/feedback']" routerLinkActive="router-link-active" expand="block" fill="clear">
                {{'Contact us' | translate}}
            </ion-button>
        </ion-card-content>
    </ion-card>
    <!-- END DESKTOP VIEW -->
    }

    @if (canViewOnDevice && isTablet && platform.isPortrait()) {
        <div class="ion-text-center">
            <div style="height: 5vh"></div>

            <ion-icon style="font-size: 50px;" slot="icon-only" name="tablet-portrait"></ion-icon>
            <ion-icon style="font-size: 50px;" slot="icon-only" name="arrow-forward-outline"></ion-icon>
            <ion-icon style="font-size: 50px;" slot="icon-only" name="tablet-landscape"></ion-icon>

            <div style="height: 5vh"></div>

            <ion-card>
                <ion-card-header>
                    <ion-card-title>{{'Official's view for tablets is only available in the landscape mode. Turn your tablet
                        horizontally.' | translate}}</ion-card-title>
                </ion-card-header>
            </ion-card>
        </div>
    }

    @if (canViewOnDevice && isMobile && platform.isLandscape()) {
        <div class="ion-text-center">
            <div style="height: 5vh"></div>

            <ion-icon style="font-size: 50px;" slot="icon-only" name="phone-landscape"></ion-icon>
            <ion-icon style="font-size: 50px;" slot="icon-only" name="arrow-forward-outline"></ion-icon>
            <ion-icon style="font-size: 50px;" slot="icon-only" name="phone-portrait"></ion-icon>

            <div style="height: 5vh"></div>

            <ion-card>
                <ion-card-header>
                    <ion-card-title>{{'Official's view for phones is only available in the portrait mode. Turn your phone
                        vertically.' | translate}}</ion-card-title>
                </ion-card-header>
            </ion-card>
        </div>
    }

</ion-content>

<!-- TEMPLATES -->
<ng-template #segmentTmp>
    @if (match) {
    <ion-segment value="scoring" (ionChange)="segmentChanged($event)" mode="md">
        <ion-segment-button value="scoring">
            <ion-label>{{'Scoring' | translate}}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="points">
            <ion-label>{{'Points' | translate}}</ion-label>
        </ion-segment-button>
        @if (match.discipline !== 'PICKLEBALL' && match.discipline !== 'BADMINTON' && match.discipline !== 'TABLE_TENNIS' && match.discipline !== 'SQUASH') {
        <ion-segment-button value="violation">
            <ion-label>{{'Violations' | translate}}</ion-label>
        </ion-segment-button>
        }
    </ion-segment>
    }
</ng-template>

<ng-template #scoringButtons>
    <ion-row [style.height.px]="rowHeight / 2">
        @if (match.discipline !== 'PICKLEBALL' && match.discipline !== 'BADMINTON' && match.discipline !== 'TABLE_TENNIS' && match.discipline !== 'SQUASH') {
        <ion-col>
            <ion-button [disabled]="isCompleted() || isInterrupted()" class="ion-no-margin btn"
                [style.font-size.px]="rowHeight / 8 "
                [style.--background]="sideColors[match.score?.server?.sideNumber - 1]" (click)="ace()">
                {{ 'Ace' | translate }}
            </ion-button>
        </ion-col>

        <ion-col class="ion-no-padding">
            <ion-button [disabled]="isCompleted() || isInterrupted()" class="ion-no-margin btn"
                [style.font-size.px]="rowHeight / 8"
                [style.--background]="sideColors[match.score?.server?.sideNumber - 1]" (click)="fault('O')">
                @if (!isDoubleFault) {
                    {{ 'Fault' | translate }}
                } @else {
                    {{ 'Double' | translate }}<br />{{ 'Fault' | translate }}
                }
            </ion-button>
        </ion-col>

        <ion-col class="ion-no-padding">
            <ion-button class="ion-no-margin btn" [style.font-size.px]="rowHeight / 8"
                [style.--background]="sideColors[match.score?.server?.sideNumber - 1]" (click)="fault('FOOT_FAULT')">
                {{ 'Foot' | translate }}<br />{{ 'Fault' | translate }}
            </ion-button>
        </ion-col>
        }

        <ion-col>
            <ion-button class="ion-no-margin btn" color="danger" [style.font-size.px]="rowHeight / 8" (click)="undo()">
                {{ 'Undo' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ng-template>

<ng-template #playerBoxTemplate>
    <ion-row #playerBox>
        <ion-col size=6 class="player-box-right-border player-box-bottom-border">
            <app-player-box [team]="getTeam(isReverse ? 2 : 1)" [match]="match" [score]="match?.score"
                [sideNumber]="isReverse ? 2 : 1" [screenPositionLeftRight]="'LEFT'" [screenPositionTopBottom]="'TOP'"
                [boxHeight]="rowHeight" [sideColor]="isReverse ? sideColors[1] : sideColors[0]"></app-player-box>
        </ion-col>

        <ion-col size=6 class="player-box-right-border player-box-bottom-border">
            <app-player-box [team]="getTeam(isReverse ? 1 : 2)" [match]="match" [score]="match?.score"
                [sideNumber]="isReverse ? 1 : 2" [screenPositionLeftRight]="'RIGHT'" [screenPositionTopBottom]="'TOP'"
                [boxHeight]="rowHeight" [sideColor]="isReverse ? sideColors[0] : sideColors[1]"></app-player-box>
        </ion-col>

        @if (match.matchType === 'D') {
        <ion-col size=6 class="player-box-right-border player-box-bottom-border player-box-left-border">
            <app-player-box [team]="getTeam(isReverse ? 2 : 1)" [match]="match" [score]="match?.score"
                [sideNumber]="isReverse ? 2 : 1" [screenPositionLeftRight]="'LEFT'" [screenPositionTopBottom]="'BOTTOM'"
                [boxHeight]="rowHeight" [sideColor]="isReverse ? sideColors[1] : sideColors[0]"></app-player-box>
        </ion-col>

        <ion-col size=6 class="player-box-bottom-border">
            <app-player-box [team]="getTeam(isReverse ? 1 : 2)" [match]="match" [score]="match?.score"
                [sideNumber]="isReverse ? 1 : 2" [screenPositionLeftRight]="'RIGHT'"
                [screenPositionTopBottom]="'BOTTOM'" [boxHeight]="rowHeight"
                [sideColor]="isReverse ? sideColors[0] : sideColors[1]"></app-player-box>
        </ion-col>
        }
    </ion-row>
</ng-template>

<ng-template #gameScoreTemplate>
    <div style="position: relative;">
        @for (set of match.score?.sets; let last = $last; let x = $index; track x) {
        <ion-row class="ion-align-items-center">
            <ion-col size="6" class="set set-border-right" [ngClass]="{'set-border-bottom': !last}"
                (click)="addGame({sideNumber: isReverse ? 2 : 1})">
                <div [style.line-height.px]="rowHeight / match.score.sets.length - 5"
                    [style.font-size.px]="(rowHeight / match.score.sets.length - 5)*0.4" [style.font-weight]="700"
                    [style.color]="getWinningSetColor(set, isReverse ? 2 : 1)">
                    {{ getGameScore(set, isReverse ? 2 : 1) }}<sup>{{ isReverse ? set.side2TiebreakScore :
                        set.side1TiebreakScore }}</sup>
                </div>
            </ion-col>
            <ion-col size="6" class="set" [ngClass]="{'set-border-bottom': !last}"
                (click)="addGame({sideNumber: isReverse ? 1 : 2})">
                <div [style.line-height.px]="rowHeight / match.score.sets.length - 5"
                    [style.font-size.px]="(rowHeight / match.score.sets.length - 5)*0.4" [style.font-weight]="700"
                    [style.color]="getWinningSetColor(set, isReverse ? 1 : 2)">
                    {{ getGameScore(set, isReverse ? 1 : 2) }}<sup>{{ isReverse ? set.side1TiebreakScore :
                        set.side2TiebreakScore }}</sup>
                </div>
            </ion-col>
        </ion-row>
        }

        @if (match.discipline !== 'PICKLEBALL' && match.discipline !== 'BADMINTON' &&
        !trackerBarComponent?.isPointByPoint) {
            <div class="game-button">
                {{'Game by game mode is on' | translate}}
            </div>
        }

    </div>

</ng-template>

<!-- IMPOARTED COMPONENTS -->
@if (match) {
    <app-tracker-board hidden [match]="match" #board [shotStatsBoard]="false"></app-tracker-board>
    <app-tracker-bar hidden [match]="match" #trackerBar [isTracker]="isTracker" [isOwner]="isOwner"
        (stopTimedSet)="board.completeTimedSet()"></app-tracker-bar>
}


<!-- TEMPLATES -->
<ng-template #segmentDropdown>
    <ion-list class="centered-select">
        <ion-item>
            <ion-select aria-label="View Mode" interface="popover" placeholder="Select view"
                [(ngModel)]="selectedSegment" (ionChange)="segmentChanged($event)">

                <ion-select-option value="scoring">{{'Scoring' | translate}}</ion-select-option>
                <ion-select-option value="points">{{'Points' | translate}}</ion-select-option>
                @if (match && match?.discipline !== 'PICKLEBALL' && match?.discipline !== 'BADMINTON' && match?.discipline !== 'TABLE_TENNIS' && match?.discipline !== 'SQUASH') {
                <ion-select-option value="violation">{{'Violations' | translate}}</ion-select-option>
                }

                <ion-icon slot="icon" name="caret-down-outline"></ion-icon>
            </ion-select>
        </ion-item>
    </ion-list>
</ng-template>